import { routes } from "~/core/constants/routes";

import { faArrowRight } from "@fortawesome/pro-regular-svg-icons";

import type { ICommandbarItem } from "../types/common";
import { CommandbarFilterTabType, CommandbarItemType } from "../types/common";

export const commandbarNavigationCommands: ICommandbarItem[] = [
  {
    id: "go-to-opportunities",
    label: "Go to Opportunities",
    type: CommandbarItemType.PAGE,
    objectType: CommandbarFilterTabType.OPPORTUNITY,
    href: routes.opportunity.index,
    faIcon: faArrowRight,
    ctaLabel: "Open",
  },
  {
    id: "go-to-contacts",
    label: "Go to Contacts",
    type: CommandbarItemType.PAGE,
    objectType: CommandbarFilterTabType.CONTACT,
    href: routes.contact.index,
    faIcon: faArrowRight,
    ctaLabel: "Open",
  },
  {
    id: "go-to-accounts",
    label: "Go to Accounts",
    type: CommandbarItemType.PAGE,
    objectType: CommandbarFilterTabType.ACCOUNT,
    href: routes.account.index,
    faIcon: faArrowRight,
    ctaLabel: "Open",
  },
  {
    id: "go-to-forms",
    label: "Go to Forms",
    type: CommandbarItemType.PAGE,
    href: routes.forms.index,
    faIcon: faArrowRight,
    ctaLabel: "Open",
  },
  {
    id: "go-to-automations",
    label: "Go to Automations",
    type: CommandbarItemType.PAGE,
    href: routes.workflows.index,
    faIcon: faArrowRight,
    ctaLabel: "Open",
  },
  {
    id: "go-to-leads",
    label: "Go to Leads",
    type: CommandbarItemType.PAGE,
    href: routes.visitors,
    faIcon: faArrowRight,
    ctaLabel: "Open",
  },
  {
    id: "go-to-inbox",
    label: "Go to Email Inbox",
    type: CommandbarItemType.PAGE,
    href: routes.emails.index,
    faIcon: faArrowRight,
    ctaLabel: "Open",
  },
  {
    id: "go-to-draft-emails",
    label: "Go to Draft Emails",
    type: CommandbarItemType.PAGE,
    href: routes.emails.draft,
    faIcon: faArrowRight,
    ctaLabel: "Open",
  },
  {
    id: "go-to-scheduled-emails",
    label: "Go to Scheduled Emails",
    type: CommandbarItemType.PAGE,
    href: routes.emails.scheduled,
    faIcon: faArrowRight,
    ctaLabel: "Open",
  },
  {
    id: "go-to-meetings",
    label: "Go to Meetings",
    type: CommandbarItemType.PAGE,
    href: routes.meetings.index,
    faIcon: faArrowRight,
    ctaLabel: "Open",
  },
  {
    id: "go-to-notes",
    label: "Go to Notes",
    type: CommandbarItemType.PAGE,
    href: routes.notes,
    faIcon: faArrowRight,
    ctaLabel: "Open",
  },
  {
    id: "go-to-tasks",
    label: "Go to Tasks",
    type: CommandbarItemType.PAGE,
    href: routes.tasks,
    faIcon: faArrowRight,
    ctaLabel: "Open",
  },
  {
    id: "go-to-profile-settings",
    label: "Go to Profile Settings",
    type: CommandbarItemType.PAGE,
    href: routes.settings.index,
    faIcon: faArrowRight,
    ctaLabel: "Open",
  },
  {
    id: "go-to-workspace-settings",
    label: "Go to Workspace Settings",
    type: CommandbarItemType.PAGE,
    href: routes.settings.organization,
    faIcon: faArrowRight,
    ctaLabel: "Open",
  },
  {
    id: "invite-members",
    label: "Go to members and invite",
    type: CommandbarItemType.PAGE,
    href: routes.settings.organizationMembers,
    faIcon: faArrowRight,
    ctaLabel: "Open",
  },
  {
    id: "go-to-integrations",
    label: "Go to Integrations",
    type: CommandbarItemType.PAGE,
    href: routes.settings.integrations.index,
    faIcon: faArrowRight,
    ctaLabel: "Open",
  },
  {
    id: "go-to-home",
    label: "Go to Home",
    type: CommandbarItemType.PAGE,
    href: routes.appDefaultLanding,
    faIcon: faArrowRight,
    ctaLabel: "Open",
  },
];
